import { fetchRecurringTransactionsAPI } from "../../../infrastructure/api/transactions";
import { RecurringTransaction } from "../../types/RecurringTransaction";

/**
 * Fetch recurring transactions.
 *
 * @param accessToken - The authentication token.
 * @returns A promise that resolves to an array of recurring transactions.
 */
export const fetchRecurringTransactions = async (
  accessToken: string,
): Promise<RecurringTransaction[]> => {
  try {
    return await fetchRecurringTransactionsAPI(accessToken);
  } catch (error) {
    console.error("Error in fetchRecurringTransactions:", error);
    throw error;
  }
};
